import React, { useState } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import PoleMarker from './PoleMarker';
import mapStyle from '../assets/json/google_map_styles.json';
import { defaultCenterType, poleType, setCenterType, setMapType, showInfoTabType } from '../types/customTypes';
import SearchPole from './SearchPole';
import '../assets/styles/GoogleMapComponent.scss';
import position from '../assets/Images/position.png';
import bluecircle from '../assets/Images/bluecircle.png';

const containerStyle = {
    height: '90vh'
};

const GoogleMapComponent:React.FC<propTypes> = (props: propTypes) => {
     //To navigate to filter tab if user clicks on map
    const [currentLocation, setCurrentLocation] = useState({lat: 0, lng: 0});

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_API_KEY
    });

    const onLoad = (map) => {
        // code commented for issue regarding Zooming in and Zooming out in Pole level#2739
        // const zoomLevel = this.getZoom();
        // const latLng = this.getCenter();
        // if (zoomLevel === 12) props.goToSchools(latLng);
        // else if (zoomLevel === 17) props.goToPoles(latLng);
        props.setMap(map);
    };

    const renderMarkers = () => {
        return (
            <PoleMarker 
                poles={props.poles} 
                showInfoTab={props.showInfoTab} 
                resetData={props.resetData} 
                isImagesLoading={props.isImagesLoading} 
                controlImageCreation={props.controlImageCreation} 
                getMapImage={props.getMapImage}  
                setCenter={props.setCenter}
                {...props}
            />
        );
    };

    const goToCurrentLocation = () => {
        navigator?.geolocation?.getCurrentPosition(pos => {
            const { latitude, longitude } = pos.coords;
            setCurrentLocation({lat: latitude, lng: longitude});
            props.setCenter({ latitude, longitude }, 17);
        });
    };

    const getPoleColor = (p) => {
        if (p.high > 0) return  'red';
        if (p.medium > 0) return 'orange';
        if (p.low > 0) return  'yellow';
        return  'white';
    };

    return isLoaded ? (
        <>
            {!props.poles[0].isSchool && !props.isImagesLoading &&
                <SearchPole
                    poles={
                        props.poles.filter(p => p.visible)
                        .map(p => ({id: p.pole_Id, name: p.pole_Number, latitude: p.latitude, longitude: p.longitude, color: getPoleColor(p)}))
                        .sort((a, b) => a.name.localeCompare(b.name, 'en',{ numeric: true }))
                    }
                    setCenter={props.setCenter}
                    setMap={props.setMap}
                    goToPoles={props.goToPoles}
                    showInfoTab={props.showInfoTab}
                />
            }
            {!props.poles[0].isSchool && !props.isImagesLoading &&
                <img src={position} id="current-location-btn" className="pointer" data-testid="current-location-btn" title="Current Location" onClick={goToCurrentLocation} />
            }
            {isLoaded &&
                <GoogleMap mapTypeId={'roadmap'}
                    // defaultZoom={props.defaultZoom}
                    mapContainerStyle={containerStyle}
                    zoom={props.defaultZoom}
                    // defaultCenter={props.defaultCenter}
                    center={props.defaultCenter}
                    onLoad={onLoad}
                    onClick={props.resetPoleData}
                    options={{
                        styles: mapStyle,
                        mapTypeControlOptions: {
                            position: 9,
                            style: 1,
                            mapTypeIds:  !props.isImagesLoading
                            ? ['roadmap', 'satellite']
                            : ['roadmap'], // Conditionally include 'satellite'
                        },
                        disableDefaultUI: true,
                        zoomControl: !props.isImagesLoading,
                        mapTypeControl: !props.isImagesLoading,
                        scaleControl: true,
                        fullscreenControl: !props.isImagesLoading
                    }}
                >
                    {renderMarkers()}
                    <Marker position={currentLocation} icon={bluecircle}></Marker>
                </GoogleMap>
            }
        </>
    ) : <></>;
};

type propTypes = {
    setMap: setMapType,
    poles: poleType[],
    defaultZoom: number,
    defaultCenter: defaultCenterType,
    resetPoleData: () => void,
    showInfoTab: showInfoTabType,
    resetData: boolean,
    setCenter: setCenterType
    goToPoles: (a) => void,
    selectedPoleId: string, 
    isImagesLoading: boolean,
	controlImageCreation : (a) => void,
	getMapImage: () => void
};

export default GoogleMapComponent;